/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfitafter2Inputs */

const en_coverfitafter2 = /** @type {(inputs: Coverfitafter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjusted`)
};

const de_coverfitafter2 = /** @type {(inputs: Coverfitafter2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepasst`)
};

/**
* | output |
* | --- |
* | "Adjusted" |
*
* @param {Coverfitafter2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfitafter2 = /** @type {((inputs?: Coverfitafter2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfitafter2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfitafter2(inputs)
	return de_coverfitafter2(inputs)
});
export { coverfitafter2 as "coverFitAfter" }